import { useMutation } from 'react-query';
import { API } from '../../CommonUtils/axiosWithDefaults';

interface ProcessBatchParams {
  batchId: string;
}

const processBatch = async ({ batchId }: ProcessBatchParams): Promise<{ success: boolean }> => {
  return API.post(`/Adviser/PdfImport/ProcessBatch?batchId=${encodeURIComponent(batchId)}`);
};

export const usePdfProcessBatchMutation = () => {
  return useMutation(processBatch);
};
